var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42806",
    "data-name": "Group 42806",
    transform: "translate(-16424 -140)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3696",
    "data-name": "Ellipse 3696",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(16424 140)",
    fill: "#15b5d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42821",
    "data-name": "Group 42821",
    transform: "translate(-1025 111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(17452.697 32.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refund",
    transform: "translate(0 -0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "refund-2",
    "data-name": "refund",
    d: "M16.606,8.3A8.288,8.288,0,1,1,.029,8.3a.554.554,0,0,1,1.107,0,7.188,7.188,0,1,0,.746-3.2H3.04a.554.554,0,0,1,0,1.107H.554A.554.554,0,0,1,0,5.654V3.011a.554.554,0,0,1,1.107,0V4.2A8.285,8.285,0,0,1,16.606,8.3Z",
    transform: "translate(0 0.006)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42791",
    "data-name": "Group 42791",
    transform: "translate(17452.16 34.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42789",
    "data-name": "Group 42789",
    transform: "translate(5.996 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189468",
    "data-name": "Path 189468",
    d: "M9.06,11a.4.4,0,0,1-.306-.131L6.129,8.244a.4.4,0,0,1-.087-.481A.383.383,0,0,1,6.435,7.5H7.748a1.192,1.192,0,0,0,.919-.394,1.192,1.192,0,0,0,.394-.919,1.192,1.192,0,0,0-.394-.919,1.192,1.192,0,0,0-.919-.394H6.435A.413.413,0,0,1,6,4.438.413.413,0,0,1,6.435,4h4.813a.413.413,0,0,1,.438.438.413.413,0,0,1-.437.438H9.5a2.358,2.358,0,0,1,.438,1.313,2.052,2.052,0,0,1-.656,1.531,2.052,2.052,0,0,1-1.531.656H7.485l1.881,1.881a.423.423,0,0,1,0,.613A.4.4,0,0,1,9.06,11Z",
    transform: "translate(-5.996 -4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42790",
    "data-name": "Group 42790",
    transform: "translate(5.998 5.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189469",
    "data-name": "Path 189469",
    d: "M11.25,8.875H6.438a.438.438,0,0,1,0-.875H11.25a.438.438,0,0,1,0,.875Z",
    transform: "translate(-6 -8)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRefund);
export default __webpack_public_path__ + "static/media/TotalRefund.3718ea2e414e81e9218d5b84b5a67ac7.svg";
export { ForwardRef as ReactComponent };